import React from "react";

import {
  IconButton,
  IconButtonProps,
  useMediaQuery,
  useTheme
} from "@mui/material";

import ArrowLeftSmall from "~public/icons/Arrow Left Small/Arrow Left Small.svg";

interface ArrowButtonProps extends IconButtonProps {
  icon: typeof ArrowLeftSmall;
}

export const ArrowButton = ({
  icon,
  ...otherProps
}: ArrowButtonProps): JSX.Element => {
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));

  const Icon = icon;
  return (
    <IconButton
      sx={{
        "& path": {
          fill: "#667085"
        },
        "&:disabled": {
          "& path": {
            fill: "#D0D5DD"
          }
        }
      }}
      {...otherProps}>
      <Icon style={{ width: isGreaterThanTablet ? "84px" : "" }} />
    </IconButton>
  );
};
